<template>
  <div>
    <v-card elevation="1" class="pa-8">
      <h2 class="page-title">โครงการรับคำเสนอขอขายไฟฟ้า</h2>
      <v-row class="mt-5 mb-7" id="sectionSearch">
        <v-col cols="12" sm="4">
          <v-dialog ref="dialog_start" v-model="modal_start" :return-value.sync="date_start" persistent width="290px">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field v-model="date_start" label="วันที่เริ่มต้น" append-icon="far fa-calendar-alt" readonly
                v-bind="attrs" v-on="on" color="purple lighten-2"></v-text-field>
            </template>
            <v-date-picker v-model="date_start" scrollable color="purple" locale="th-th" :max="date_end">
              <v-spacer></v-spacer>
              <v-btn class="ppim-btn" color="grey" text @click="modal_start = false">ยกเลิก</v-btn>
              <v-btn class="ppim-btn" color="purple lighten-2" dark depressed
                @click="$refs.dialog_start.save(date_start)">ยืนยัน</v-btn>
            </v-date-picker>
          </v-dialog>
        </v-col>
        <v-col cols="12" sm="4">
          <v-dialog ref="dialog_end" v-model="modal_end" :return-value.sync="date_end" persistent width="290px">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field v-model="date_end" label="วันที่สิ้นสุด" append-icon="far fa-calendar-alt" readonly
                v-bind="attrs" v-on="on" color="purple lighten-2"></v-text-field>
            </template>
            <v-date-picker v-model="date_end" scrollable color="purple" locale="th-th" :min="date_start">
              <v-spacer></v-spacer>
              <v-btn class="ppim-btn" color="grey" text @click="modal_end = false">ยกเลิก</v-btn>
              <v-btn class="ppim-btn" color="purple lighten-2" dark depressed
                @click="$refs.dialog_end.save(date_end)">ยืนยัน</v-btn>
            </v-date-picker>
          </v-dialog>
        </v-col>
        <v-col cols="12" sm="4">
          <v-select :items="status_items" label="สถานะโครงการ" item-text="text" item-value="value" v-model="status"
            color="purple lighten-2" item-color="purple"></v-select>
        </v-col>
        <v-col cols="12" class="text-center pa-0">
          <v-btn class="ppim-btn mr-2" color="purple darken-2" depressed dark @click="search">
            <v-icon small left>fas fa-search</v-icon>ค้นหา
          </v-btn>
          <v-btn class="ppim-btn" color="purple lighten-2" depressed @click="clearFilter" dark>ล้างตัวกรอง</v-btn>
        </v-col>
      </v-row>
      <v-row id="sectionDataTable">
        <v-col cols="12">
          <v-data-table :headers="headers" :items="projects" :items-per-page="10" mobile-breakpoint="xs">
            <template v-slot:item.project_startdate="{ item }">
              <span class="text-no-wrap">
                {{ getDate(item.project_startdate) }}
              </span>
            </template>
            <template v-slot:item.project_enddate="{ item }">
              <span class="text-no-wrap">
                {{ getDate(item.project_enddate) }}
              </span>
            </template>
            <template v-slot:item.project_status="{ item }">
              <span :class="[item.project_status == 1 ? 'light-green--text text--darken-2' : 'red--text']">
                {{ projectStatus[item.project_status] }}
              </span>
            </template>
            <template v-slot:item.project_detail="{ item }">
              <!-- <div v-if="item.project_status == 1"> -->
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn color="purple darken-2" elevation="0" fab dark small v-bind="attrs" v-on="on"
                    :to="{ name: 'project-eco-view', params: { pid: item.project_code } }">
                    <v-icon small>fas fa-file-alt</v-icon>
                  </v-btn>
                </template>
                <span>คลิกดูรายละเอียด</span>
              </v-tooltip>
              <!-- </div> -->
              <!-- <div v-else>
                <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            fab
                            small
                            elevation="0"
                            v-bind="attrs"
                            v-on="on"
                            :to="{ name: 'project-eco-view', params: { pid: item.project_code } }"
                        >
                            <v-icon small>fas fa-file-alt</v-icon>
                        </v-btn>
                    </template>
                    <span>คลิกดูรายละเอียด</span>
                </v-tooltip>
              </div> -->
            </template>
            <template v-slot:item.project_announce="{ item }">
              <v-icon v-if="(item.is_announce_technic != true && item.is_announce_price != true)">fas fa-minus</v-icon>
              <!-- ประกาศผลเทคนิค -->
              <v-tooltip v-if="item.is_announce_technic == true" top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn color="pink lighten-3" elevation="0" dark small fab v-bind="attrs" v-on="on"
                    :to="{ name: 'project-eco-announce', params: { consider_type: 'technic', pid: item.project_code } }">
                    <v-icon small>fas fa-bolt</v-icon>
                  </v-btn>
                </template>
                <span>คลิกดูประกาศผลเทคนิค</span>
              </v-tooltip>
              <!-- ประกาศผลราคา -->
              <v-tooltip v-if="item.is_announce_price == true" top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn color="purple lighten-2" elevation="0" dark small fab v-bind="attrs" v-on="on"
                    :to="{ name: 'project-eco-announce', params: { consider_type: 'price', pid: item.project_code } }"
                    class="ml-1">
                    <v-icon small>fas fa-tag</v-icon>
                  </v-btn>
                </template>
                <span>คลิกดูประกาศผลราคา</span>
              </v-tooltip>
              <!-- <v-icon>fas fa-minus</v-icon> -->
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import { DateTime } from '@/plugins/app'
import api from "@/plugins/axios"
export default {
  data: () => ({
    date_start: null,
    modal_start: false,
    date_end: null,
    modal_end: false,
    status: "1",
    status_items: [
      {
        text: "ทั้งหมด",
        value: ""
      },
      {
        text: "ปิด",
        value: "0"
      },
      {
        text: "เปิด",
        value: "1"
      }
    ],
    headers: [
      { text: "รหัสโครงการ", value: "project_code" },
      { text: "ชื่อโครงการ", value: "project_title" },
      { text: "วันที่เริ่มต้น", value: "project_startdate", align: "center" },
      { text: "วันที่สิ้นสุด", value: "project_enddate", align: "center" },
      { text: "สถานะ", value: "project_status", align: "center" },
      { text: "ข้อมูลโครงการ", value: "project_detail", align: "center", sortable: false },
      { text: "ประกาศผล", value: "project_announce", align: "center", sortable: false, width: 116 }
    ],
    projects: [],
    projectStatus: ["ปิด", "เปิด"]
  }),
  methods: {
    getData: function () {
      let date_start = this.date_start == null ? DateTime.fromISO("1990-01-01").toISO() : DateTime.fromISO(this.date_start).toISO();
      let date_end = this.date_end == null ? null : DateTime.fromISO(this.date_end).endOf('day').toISO();
      let status = this.status;

      api.get("/project/eco", {
        params: {
          start_date: date_start,
          end_date: date_end,
          status: status
        }
      })
        .then(response => {
          this.projects = response.data;
        });
    },
    search: function () {
      this.getData();
    },
    clearFilter: function () {
      this.date_start = null;
      this.date_end = null;
      this.status = "";
    },
    showDetail(projectCode) {
      alert(projectCode);
    },
    getDate(set_date) {
      if (!set_date)
        return '-'

      let date = DateTime.fromISO(set_date).toFormat('yyyy-MM-dd HH:mm:ss');
      return date;
    },
  },
  created() {
    //api.get("/project/eco");
    this.getData();
  }
};
</script>

